import {Directive, ElementRef} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../../provider/message-service/message.service';
import {Subscription} from 'rxjs';

@Directive({
    selector: '[appMessages]'
})
export class MessagesDirective {

    subsription: Subscription;

    constructor(private element: ElementRef,
                private router: Router,
                private msgService: MessageService) {

        // console.log('MessagesDirective ------------->: ', element);
    }

}
